<template>
  <div class="four">
    <news
      style="flex: 1"
      url="home/HomeGetSzNews"
      :param="{ top: 4, index:4 }"
      text="先锋模范"
      type="3"
      more-url="/main?type=1&selected=3"
    />
    <news
      style="flex: 1; margin-left: 20px"
      url="home/HomeGetSzNews"
      :param="{ top: 4, index:5 }"
      text="办事流程"
      type="3"
      more-url="/main?type=1&selected=5"
    />
    <news
      style="flex: 1; margin-left: 20px"
      url="home/HomeGetSzNews"
      :param="{ top: 4, index: 9 }"
      text="三务公开"
      type="3"
      more-url="/main?type=4&selected=0"
    />

  </div>
</template>

<script>
import news from '../news.vue'
export default {
  components: {
    news
  },
  data() {
    return {}
  },

  mounted() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
.four {
  display: flex;
  height: 460.5px;
}
</style>
